import BaseSubscriptionModal from 'app/components/subscriptionModals/BaseSubscriptionModal';
import Benefits from 'app/components/subscriptionModals/Benefits';
import postIcon from 'app/images/postsModalGreet.svg';
import { FC } from 'react';
import { SUBSCRIPTION_MODAL_BENEFITS } from './subscriptionModalBenefits';
import SubscriptionExpiredButtons from './SubscriptionExpiredButtons';
import SubscriptionExpiredFooter from './SubscriptionExpiredFooter';
import { useTranslation, Trans } from 'react-i18next';

type Props = {
  open: boolean;
};

const TrialExpired: FC<Props> = ({ open }) => {
  const { t } = useTranslation();

  return (
    <BaseSubscriptionModal
      open={open}
      title={
        <div className="tw-text-xl tw-font-medium">
          <Trans
            i18nKey="subscription.trialExpired.title"
            components={{ 1: <strong /> }}
          />
        </div>
      }
      image={<img src={postIcon} alt="Post icon" />}
      buttons={
        <SubscriptionExpiredButtons
          primaryText={t('subscription.trialExpired.choosePlanButton')}
        />
      }
      benefits={
        <Benefits
          title={t('subscription.trialExpired.benefitsTitle')}
          lists={SUBSCRIPTION_MODAL_BENEFITS.posts}
        />
      }
      footer={
        <SubscriptionExpiredFooter
          text={t('subscription.trialExpired.footerText')}
        />
      }
    />
  );
};

export default TrialExpired;
